export const emailRegex =
  /^([a-zA-Z0-9_\-.]+)(\+[\w]+)?@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,9})$/i;
